import { React, useState, useEffect } from "react";
import request from "../../../Helpers/API";
import {
  Modal,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { ValIsEmail } from "../../../Validators/ValIsEmail";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import { fechaMMDDaInput, hoyLocal } from "../../../Helpers/FormatFecha";

export const EditarFaseModal = ({ open, onClose, folio, idcliente }) => {
  const [titulo, setTitulo] = useState("CAMBIAR FASE");
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [fase, setFase] = useState();
  const [mes, setMes] = useState();
  const [anio, setAnio] = useState();
  const [motivo, setMotivo] = useState();
  const [comentario, setComentario] = useState("");

  const today = hoyLocal();

  const [facturado, setFacturado] = useState({
    fechaEntrega: today,
    entregado: "N",
    folioSolicitud: "",
    contacto_servicio: "",
    contacto_refacciones: "",
    contacto_ventas: "",
    cargado: false,
    deshabilitado: false,
  });

  const [solicitudes, setSolicitudes] = useState([]);
  const [contactoServicio, setContactoServicio] = useState([]);
  const [contactoRefacciones, setContactoRefacciones] = useState([]);
  const [contactoVentas, setContactoVentas] = useState([]);

  // useEffect(() => {
  //     setFase(faseCotizacion)
  // }, [open]);

  const generarFaseFinal = () => {
    if (fase === "IN") {
      return `IN - ${mes}/${anio}`;
    }

    if (fase === "NC") {
      return `NC - ${comentario || ""}`;
    }

    if (fase === "VP") {
      return `VP - ${motivo || ""}`;
    }

    return fase;
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Cotizaciones/GetFase?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        // El backend regresa MM/dd/yyyy HH:mm:ss; se parsea explicito porque Safari no lo interpreta.
        const formatFecha = (fecha) => fechaMMDDaInput(fecha);

        const fullFase = result[0]?.fase_cotizacion || "";
        const tipoFase = fullFase.substring(0, 2);
        const detalle = fullFase.split(" - ")[1] || "";
        const comentario = result[0]?.comentario_fase || "";

        setFacturado({
          ...facturado,
          fechaEntrega:
            result[0]?.fecha_entrega === "01/01/1900 00:00:00"
              ? today
              : formatFecha(result[0]?.fecha_entrega),
          entregado: result[0]?.entregado || "N",
          folioSolicitud: result[0]?.folio_solicitud || "",
          // contacto_servicio: result[0]?.contacto_servicio || "",
          // contacto_refacciones: result[0]?.contacto_refacciones || "",
          // contacto_ventas: result[0]?.contacto_ventas || "",
          cargado: !!result[0]?.folio_solicitud,
          deshabilitado: result[0]?.entregado === "S" ? true : false,
        });
        setFase(tipoFase);

        setComentario(comentario)
        if (tipoFase === "IN") {
          const [mesStr, anioStr] = detalle.split("/");
          setMes(parseInt(mesStr));
          setAnio(parseInt(anioStr));
        } else if (tipoFase === "VP") {
          setMotivo(detalle);
        } else if (tipoFase === "NC") {
          setComentario(detalle || comentario);
        }

        return;
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        return;
      });
    setLoader({ ...loader, mostrar: false });
  }, [open]);

  useEffect(() => {
    if (fase === "VN" && idcliente !== 0) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`Cotizaciones/ObtenerSolicitudes?idcliente=${idcliente}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setSolicitudes(result.solicitudes);
          setContactoServicio(result.contacto_servicio);
          setContactoRefacciones(result.contacto_refacciones);
          setContactoVentas(result.contacto_ventas);

          setFacturado({
            ...facturado,
            contacto_servicio: result.contacto_servicio?.[0] || "",
            contacto_refacciones: result.contacto_refacciones?.[0] || "",
            contacto_ventas: result.contacto_ventas?.[0] || "",
          });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          return;
        });
    }
  }, [fase]);

  const generarComentarioFase = ({ comentario, fase, mes, anio, motivo }) => {
    if (comentario && comentario.trim() !== "" && fase !== 'IN' && fase !== 'VP') {
      return comentario;
    }

    const motivosVentaPerdida = {
      PR: "Precio",
      DP: "Disponibilidad",
      CT: "Caracteristicas tecnicas o rendimiento",
      OF: "Ofertas del usado",
      FN: "Opciones del financiamiento",
      LM: "Lealtad a otra marca",
      BC: "Baja confiabilidad"
    };

    const fases = {
      PR: "Se entrego promocion",
      IN: `Cliente mostró interes en ${GetMonthNameByNumber(mes)} ${anio}`,
      NE: "En negociacion",
      CE: "Operacion cerrada",
      FM: "Se estima facturar en el mes",
      FS: "Se estima facturar en la semana",
      NC: "No compra"
    };

    if (fase === "VP") {
      const motivoTexto = motivosVentaPerdida[motivo] || "Sin motivo";
      return `Venta perdida por: ${motivoTexto}`;
    }

    return fases[fase] || "Cambio de Fase";
  };

  const onModificaFase = (folio, modoFase) => {
    // console.log(modoFase)
    if (modoFase === "VN") {
      var obligatorio = true;
      if (facturado.entregado === "S") {
        if (!/^[0-9]{10}$/.test(facturado.contacto_servicio)) {
          Swal.fire({
            title: "COTIZACIÓN",
            text: "El contacto de servicio debe contener exactamente 10 dígitos numéricos.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            customClass: {
              container: "mi-superpoop",
            },
          });

          return;
        } else {
          obligatorio = false;
        }

        if (
          !/^[0-9]{10}$/.test(facturado.contacto_refacciones) &&
          obligatorio
        ) {
          Swal.fire({
            title: "COTIZACIÓN",
            text: "El contacto de refacciones debe contener exactamente 10 dígitos numéricos.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            customClass: {
              container: "mi-superpoop",
            },
          });
          return;
        }
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!regexEmail.test(facturado.contacto_ventas) && facturado.contacto_ventas.length > 0) {
          Swal.fire({
            title: "COTIZACIÓN",
            text: "El correo electronico es obligatorio",
            icon: "warning",
            confirmButtonText: "Aceptar",
            customClass: {
              container: "mi-superpoop",
            },
          });
          return;
        }
      }

      if (facturado.fechaEntrega === "") {
        Swal.fire({
          title: "COTIZACIÓN",
          text: "Favor de introducir la fecha de entrega",
          icon: "warning",
          confirmButtonText: "Aceptar",
          customClass: {
            container: "mi-superpoop",
          },
        });
        return;
      }

      if (facturado.entregado === "") {
        Swal.fire({
          title: "COTIZACIÓN",
          text: "Favor de introducir si fue entregado",
          icon: "warning",
          confirmButtonText: "Aceptar",
          customClass: {
            container: "mi-superpoop",
          },
        });
        return;
      }

      // if (facturado.folioSolicitud === "") {
      //   Swal.fire({
      //     title: "COTIZACIÓN",
      //     text: "Favor el folio de la solicitud",
      //     icon: "warning",
      //     confirmButtonText: "Aceptar",
      //     customClass: {
      //       container: "mi-superpoop",
      //     },
      //   });
      //   return;
      // }

      const post = {
        folio_cotizacion: folio,
        fecha_entrega: facturado.fechaEntrega,
        entregado: facturado.entregado,
        folio_solicitud: facturado.folioSolicitud,
        contacto_servicio:
          facturado.contacto_servicio === ""
            ? "N"
            : facturado.contacto_servicio,
        contacto_refacciones:
          facturado.contacto_refacciones === ""
            ? "N"
            : facturado.contacto_refacciones,
        contacto_ventas: facturado.contacto_ventas,
        fase: modoFase,
        idcliente: idcliente,
      };

      setLoader({ ...loader, mostrar: true });
      request
        .post(`Cotizaciones/GuardarFacturacion`, post)
        .then(async (result) => {
          setLoader({ ...loader, mostrar: false });
          setFacturado({
            ...facturado,
            fechaEntrega: today,
            entregado: "",
            folioSolicitud: "",
            contacto_servicio: "",
            contacto_refacciones: "",
            cargado: false,
          });
          await Swal.fire({
            title: "COTIZACION",
            text: "Fase modificada con éxito",
            icon: "success",
            customClass: {
              container: "mi-superpoop",
            },
          });
          onClose();

          return;
        })
        .catch((error) => {
          Swal.fire("COTIZACION", JSON.stringify(error), "error");
          setLoader({ ...loader, mostrar: false });
          return;
        });
    } else {
      setLoader({ ...loader, mostrar: true });

      const comentarioFase = generarComentarioFase({
        comentario,
        fase,
        mes,
        anio,
        motivo
      });
      // console.log(comentarioFase)
      request
        .get(`Cotizaciones/EditarFase?folio=${folio}&fase=${modoFase}&comentario=${comentarioFase}`)
        .then(async (result) => {
          setLoader({ ...loader, mostrar: false });
          await Swal.fire({
            title: "COTIZACION",
            text: "Fase modificada con éxito",
            icon: "success",
            customClass: {
              container: "mi-superpoop",
            },
          });
          onClose();

          return;
        })
        .catch((error) => {
          Swal.fire("COTIZACION", JSON.stringify(error), "error");
          setLoader({ ...loader, mostrar: false });
          return;
        });
    }
  };

  const onChange = (prop, value, sbool, smensaje) => {
    setFacturado({
      ...facturado,
      [prop]: value,
    });
  };
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div className="editar-fase-modal-formulario">
          <div className="editar-fase-modal-plantilla">
            <div
              className="plantilla-screen-filtro-container"
              id="mdlFiltros-modal"
            >
              <PlantillaScreen
                titulo={titulo}
                className_main={1}
                className={"plantilla-screen-filtro-container-modal"}
              >
                <div className="cerrar-modal-button" onClick={onClose}>
                  X
                </div>
                <div className={`editar-fase-modal-agregar-convenio`}>
                  <div className="editar-fase-modal-agregar-convenio-container">
                    <div className="select-modelos">
                      <FormControl size="small" fullWidth sx={{ mt: 2 }}>
                        <InputLabel id="fase-label">Fase Cotizacion</InputLabel>
                        <Select
                          labelId="fase-label"
                          id="select-fase"
                          value={fase || ""}
                          label="Fase Cotizacion"
                          disabled={
                            facturado.deshabilitado === true ? true : false
                          }
                          onChange={(e) => {
                            setFase(e.target.value);
                          }}
                          sx={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            "& .MuiSelect-select": {
                              paddingY: "8px",
                            },
                            [`@media (max-height:499px)`]: {
                              height: "28px",
                              "& .MuiSelect-select": {
                                paddingY: "4px",
                              },
                            },
                          }}
                        >
                          <MenuItem key={"PR"} value={"PR"}>
                            Entregar promoción
                          </MenuItem>
                          <MenuItem key={"IN"} value={"IN"}>
                            Cliente con interés
                          </MenuItem>
                          <MenuItem key={"NE"} value={"NE"}>
                            En negociación
                          </MenuItem>
                          <MenuItem key={"CE"} value={"CE"}>
                            Operación cerrada
                          </MenuItem>
                          <MenuItem key={"FM"} value={"FM"}>
                            Se estima facturar mes
                          </MenuItem>
                          <MenuItem key={"FS"} value={"FS"}>
                            Se estima facturar semana
                          </MenuItem>
                          <MenuItem key={"NC"} value={"NC"}>
                            No compra
                          </MenuItem>
                          <MenuItem key={"VP"} value={"VP"}>
                            Venta perdida
                          </MenuItem>
                          <MenuItem key={"VN"} value={"VN"}>
                            Facturado
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {fase === "IN" ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "16px",
                      }}
                    >
                      <FormControl size="small" fullWidth>
                        <InputLabel id="anio-label">Año</InputLabel>
                        <Select
                          labelId="anio-label"
                          value={anio || ""}
                          onChange={(e) => setAnio(e.target.value)}
                          label="Año"
                        >
                          <MenuItem value={new Date().getFullYear()}>
                            {new Date().getFullYear()}
                          </MenuItem>
                          <MenuItem value={new Date().getFullYear() + 1}>
                            {new Date().getFullYear() + 1}
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" fullWidth>
                        <InputLabel id="mes-label">Mes</InputLabel>
                        <Select
                          labelId="mes-label"
                          value={mes || ""}
                          onChange={(e) => setMes(e.target.value)}
                          label="Mes"
                        >
                          {[
                            "Enero",
                            "Febrero",
                            "Marzo",
                            "Abril",
                            "Mayo",
                            "Junio",
                            "Julio",
                            "Agosto",
                            "Septiembre",
                            "Octubre",
                            "Noviembre",
                            "Diciembre",
                          ].map((mes, i) => (
                            <MenuItem key={i} value={i + 1}>
                              {mes}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : fase === "VP" ? (
                    <FormControl size="small" fullWidth sx={{ mt: 2 }}>
                      <InputLabel id="motivo-label">Motivo</InputLabel>
                      <Select
                        labelId="motivo-label"
                        value={motivo || ""}
                        onChange={(e) => setMotivo(e.target.value)}
                        label="Motivo"
                      >
                        <MenuItem value="PR">Precio</MenuItem>
                        <MenuItem value="DP">Disponibilidad</MenuItem>
                        <MenuItem value="CT">
                          Características técnicas o rendimiento
                        </MenuItem>
                        <MenuItem value="OF">Oferta del usado</MenuItem>
                        <MenuItem value="FN">
                          Opciones de financiamiento
                        </MenuItem>
                        <MenuItem value="LM">Lealtad a otra marca</MenuItem>
                        <MenuItem value="BC">
                          Baja confiabilidad del producto
                        </MenuItem>
                      </Select>
                    </FormControl>
                  ) : fase === "VN" ? (
                    <div className="editar-fase-facturado-inputs-container">
                      <div className="editar-fase-facturado-inputs-fecha-container">
                        <TextField
                          fullWidth
                          size="small"
                          label="Fecha Entrega"
                          variant="outlined"
                          className="cel-1-1"
                          type="date"
                          disabled={
                            facturado.deshabilitado === true ? true : false
                          }
                          onChange={({ target }) => {
                            setFacturado({
                              ...facturado,
                              fechaEntrega: target.value,
                            });
                          }}
                          value={facturado.fechaEntrega}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "40px",
                            },
                            "& input": {
                              padding: "0 10px",
                            },
                          }}
                        />

                        <TextField
                          fullWidth
                          size="small"
                          label="Entregado"
                          variant="outlined"
                          className="cel-1"
                          select
                          type="text"
                          disabled={
                            facturado.deshabilitado === true ? true : false
                          }
                          onChange={({ target }) => {
                            setFacturado({
                              ...facturado,
                              entregado: target.value,
                            });
                          }}
                          value={facturado.entregado}
                        >
                          <MenuItem value={"S"}>Si</MenuItem>
                          <MenuItem value={"N"}>No</MenuItem>
                        </TextField>
                      </div>

                      {idcliente !== 0 && solicitudes.length > 0 ? (
                        <TextField
                          fullWidth
                          size="small"
                          label="Solicitud"
                          variant="outlined"
                          className="cel-1"
                          select
                          disabled={
                            facturado.deshabilitado === true ? true : false
                          }
                          type="text"
                          value={facturado.folioSolicitud}
                          onChange={({ target }) => {
                            setFacturado({
                              ...facturado,
                              folioSolicitud: target.value,
                            });
                          }}
                          sx={{ marginTop: "15px" }}
                        >
                          {/* MenuItem extra si está cargado */}
                          {facturado.cargado && (
                            <MenuItem value={facturado.folioSolicitud}>
                              {facturado.folioSolicitud}
                            </MenuItem>
                          )}

                          {Array.isArray(solicitudes) &&
                            solicitudes.length > 0 &&
                            solicitudes.map((solicitud) => (
                              <MenuItem
                                key={solicitud.folio}
                                value={solicitud.folio}
                              >
                                <Tooltip
                                  title={
                                    <Box sx={{ p: 1 }}>
                                      <Typography variant="subtitle2">
                                        Detalles de la solicitud
                                      </Typography>

                                      <Typography variant="body2">
                                        Folio: {solicitud.folio}
                                      </Typography>

                                      <Typography variant="body2">
                                        Modelo: {solicitud.modelo}
                                      </Typography>

                                      <Typography variant="body2">
                                        Cantidad: {solicitud.cantidad}
                                      </Typography>

                                      <Typography variant="body2">
                                        Monto: $
                                        {solicitud.monto.toLocaleString()}
                                      </Typography>
                                    </Box>
                                  }
                                  placement="right"
                                  arrow
                                >
                                  <Box component="span" sx={{ width: "100%" }}>
                                    {solicitud.folio}
                                  </Box>
                                </Tooltip>
                              </MenuItem>
                            ))}
                        </TextField>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          label="Solicitud"
                          variant="outlined"
                          className="cel-1"
                          type="text"
                          disabled={
                            facturado.deshabilitado === true ? true : false
                          }
                          onChange={({ target }) => {
                            setFacturado({
                              ...facturado,
                              folioSolicitud: target.value,
                            });
                          }}
                          value={facturado.folioSolicitud}
                          sx={{ marginTop: "15px" }}
                        ></TextField>
                      )}

                      <TextField
                        fullWidth
                        size="small"
                        label="Contacto Servicio"
                        variant="outlined"
                        className="cel-1"
                        type="text"
                        disabled={
                          facturado.deshabilitado === true ? true : false
                        }
                        onChange={({ target }) => {
                          ValOnlyNumber(
                            "contacto_servicio",
                            target.value,
                            onChange,
                            true,
                            10,
                          );
                        }}
                        value={facturado.contacto_servicio}
                        sx={{ marginTop: "15px" }}
                      ></TextField>

                      {/* <Autocomplete
                        freeSolo
                        options={contactoServicio}
                        sx={{
                          marginTop: '15px'
                        }}
                        value={facturado.contacto_servicio || ""}
                        inputValue={facturado.contacto_servicio || ""}
                        disabled={facturado.deshabilitado === true ? true : false}
                        onInputChange={(event, value) => {
                          ValOnlyNumber(
                            "contacto_servicio",
                            value ?? "",
                            onChange,
                            true,
                            10
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            size="small"
                            label="Contacto Servicio"
                            className="cel-1"
                          />
                        )}
                      /> */}

                      <TextField
                        fullWidth
                        size="small"
                        label="Contacto Refacciones"
                        variant="outlined"
                        className="cel-1"
                        type="text"
                        disabled={
                          facturado.deshabilitado === true ? true : false
                        }
                        onChange={({ target }) => {
                          ValOnlyNumber(
                            "contacto_refacciones",
                            target.value,
                            onChange,
                            true,
                            10,
                          );
                        }}
                        value={facturado.contacto_refacciones}
                        sx={{ marginTop: "15px" }}
                      ></TextField>

                      <TextField
                        fullWidth
                        size="small"
                        label="Correo Electrónico"
                        variant="outlined"
                        className="cel-1"
                        type="text"
                        disabled={
                          facturado.deshabilitado === true ? true : false
                        }
                        onChange={({ target }) => {
                          ValIsEmail("contacto_ventas", target.value, onChange);
                        }}
                        value={facturado.contacto_ventas}
                        sx={{ marginTop: "15px" }}
                      ></TextField>
                    </div>
                  ) : (
                    <TextField
                      size="small"
                      fullWidth
                      label="Comentario"
                      multiline
                      rows={3}
                      sx={{ mt: 2 }}
                      value={comentario || ""}
                      onChange={(e) => setComentario(e.target.value)}
                    />
                  )}


                  {facturado.deshabilitado === false && (
                    <div className="editar-fase-modal-buttons">
                      <button
                        className="editar-fase-modal-button-guardar"
                        onClick={() =>
                          onModificaFase(folio, generarFaseFinal())
                        }
                      >
                        Cambiar Fase
                      </button>
                    </div>
                  )}
                </div>
              </PlantillaScreen>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
